import { BeneficialOwnersStep } from "Components/Onboarding/BusinessEntity/Steps/BeneficialOwnersStep/BeneficialOwnersStep";
import { BankAccountStep } from "Components/Onboarding/BusinessEntity/Steps/BankAccountStep/BankAccountStep";
import { BusinessInformationStep } from "Components/Onboarding/BusinessEntity/Steps/BusinessInformationStep";
import { FacilityCompletionStep } from "Components/Onboarding/BusinessEntity/Steps/FacilityCompletionStep/FacilityCompletionStep";
import { IncomeInformationStep } from "Components/Onboarding/BusinessEntity/Steps/IncomeInformationStep";
import { LicenseSelectionStep } from "Components/Onboarding/BusinessEntity/Steps/LicenseSelectionStep/LicenseSelectionStep";
import { ManualLicensePaymentStep } from "Components/Onboarding/BusinessEntity/Steps/ManualLicensePaymentStep/ManualLicensePaymentStep";
import { PersonalDocumentsStep } from "Components/Onboarding/BusinessEntity/Steps/PersonalDocumentsStep/PersonalDocumentsStep";
import { PersonalInformationStep } from "Components/Onboarding/BusinessEntity/Steps/PersonalInformationStep/PersonalInformationStep";
import { HandleStep } from "Components/Onboarding/shared/HandleStep/HandleStep";
import type { OnboardingStep } from "Components/Onboarding/BusinessEntity/constants";
import { Resources, type TFunction } from "Translations/Resources";
import type { FC } from "react";

export type StepComponent = FC<{ onNextStepRequested: () => void }>;

export const STEP_TO_CONTENT_COMPONENT: Record<OnboardingStep, StepComponent> =
  {
    businessInformation: BusinessInformationStep,
    incomeInformation: IncomeInformationStep,
    facilityCompletion: FacilityCompletionStep,
    document: PersonalDocumentsStep,
    personalInformation: PersonalInformationStep,
    handle: HandleStep,
    beneficialOwners: BeneficialOwnersStep,
    bankAccountConnection: BankAccountStep,
    licenseSelection: LicenseSelectionStep,
    manualLicensePayment: ManualLicensePaymentStep,
  };

// biome-ignore format: one line per title
export const getTranslatedTitle = (step: OnboardingStep, t: TFunction) => {
  const stepToTitle: Record<OnboardingStep, string> = {
    businessInformation: t(Resources.Onboarding.BusinessOnboarding.Steps.BusinessInformation.Title),
    incomeInformation: t(Resources.Onboarding.ProcessTitle),
    facilityCompletion: t(Resources.Onboarding.BusinessOnboarding.Steps.FacilityCompletion.Title),
    document: t(Resources.Onboarding.ProcessTitle),
    personalInformation: t(Resources.Onboarding.ProcessTitle),
    handle: t(Resources.Onboarding.ProcessTitle),
    beneficialOwners: t(Resources.Onboarding.BeneficialOwnersTitle),
    bankAccountConnection: t(Resources.Onboarding.BusinessOnboarding.Steps.BankAccount.Title),
    licenseSelection: t(Resources.Onboarding.BusinessOnboarding.Steps.LicenseSelection.Title),
    manualLicensePayment: t(Resources.Onboarding.ManualLicensePaymentTitle),
  };

  return stepToTitle[step];
};
